import React, { useState } from "react";
import { styled } from "styled-components";
import Input from "@cs/components/src/Input";
import { ExternalLink } from "react-feather";

interface Props {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}

const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 2.5fr;
  column-gap: 16px;
  align-items: center;
  padding: 3px 10px;
`;

const CronLabelCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 14px;
  text-align: right;
`;

const DocLink = styled.a`
  color: var(--blue300);
  display: inline-flex;
  align-items: center;
  gap: 5px;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const ThreeCol = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 5px;
`;

const CronField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const CronFieldLabel = styled.span`
  font-size: 13px;
  color: var(--gray300);
  text-align: center;
`;

const EditWrapper = styled.div`
  --inputBorder: var(--dark300);
  --inputBackground: var(--dark200);

  input {
    height: 30px;
    font-size: 15px;
  }
`;

const CronInput = (props: Props) => {
  const { value, onChange } = props;

  const parts = value.trim().split(" ");

  const [minute, setMinute] = useState(parts[0] ?? "");
  const [hour, setHour] = useState(parts[1] ?? "");
  const [week, setWeek] = useState(parts[4] ?? "");

  const updatePart = (key: "minute" | "hour" | "week", val: string) => {
    const newParts = [...parts];
    if (key === "minute") {
      setMinute(val);
      if (val) {
        newParts[0] = val;
      }
    } else if (key === "hour") {
      setHour(val);
      if (val) {
        newParts[1] = val;
      }
    } else if (key === "week") {
      setWeek(val);
      if (val) {
        newParts[4] = val;
      }
    }
    onChange(newParts.join(" "));
  };

  return (
    <FieldRow>
      <CronLabelCell>
        <DocLink
          href="https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-cron-expressions.html"
          target="_blank"
          rel="noreferrer"
          tabIndex={-1}
        >
          Cron
          <ExternalLink size={15} />
        </DocLink>
      </CronLabelCell>
      <ThreeCol>
        <CronField>
          <CronFieldLabel>Minute</CronFieldLabel>
          <EditWrapper>
            <Input value={minute} onChange={(v) => updatePart("minute", v)} />
          </EditWrapper>
        </CronField>
        <CronField>
          <CronFieldLabel>Hour</CronFieldLabel>
          <EditWrapper>
            <Input value={hour} onChange={(v) => updatePart("hour", v)} />
          </EditWrapper>
        </CronField>
        <CronField>
          <CronFieldLabel>Day of Week</CronFieldLabel>
          <EditWrapper>
            <Input value={week} onChange={(v) => updatePart("week", v)} />
          </EditWrapper>
        </CronField>
      </ThreeCol>
    </FieldRow>
  );
};

export default CronInput;
